import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '@shared/shared.module';
import { ProductsComponent } from './components/products/products.component';
import { ProductsRoutingModule } from './products-routing.module';
import { FormsModule } from '@angular/forms';
import { ProductDetailPageComponent } from './pages/product-detail-page.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { ProductBrandsComponent } from './components/product-brands/product-brands.component';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { SearchProductsPageComponent } from './pages/search-products-page.component';
import { ProductListPageComponent } from './pages/product-list-page.component';
import { ProductListComponent } from './components/product-list/product-list.component';

@NgModule({
    declarations: [
        ProductsComponent,
        ProductDetailPageComponent,
        ProductDetailComponent,
        ProductBrandsComponent,
        SearchProductsPageComponent,
        ProductListPageComponent,
        ProductListComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        NgxPaginationModule,
        FormsModule,
        ProductsRoutingModule
    ]
})
export class ProductsModule {}
